angular.module('unergie.main')
.controller('csrB2gHomeCtrl', ($scope, $state, $stateParams, DataAccess, ModalService, TableGeneratorService, NgTableParams,
    JiraService, AlertManager, MetaWatcher, BoFeaturesService, ErrorCatcher) => {
    $scope.selected = {}
    $scope.nbTicket = {}
    $scope.shouldDisplayContactInfo = false
    $scope.canEditAdministrableContent = BoFeaturesService.isFeatureOn('canEditAdministrableContent')

    const allCats = { name: 'TOUS' }

    $scope.accountSelection = {
        brand: undefined,
        organization: undefined,
    }
    $scope.emptyAccount = () => {
        $scope.accountSelection = {
            brand: undefined,
            organization: undefined,
        }
    }

    $scope.categorySelection = undefined
    $scope.emptyCategory = () => {
        $scope.categorySelection = undefined
        $scope.selected.category = allCats
        MetaWatcher.notif('MNG_ACCOUNT_CHANGED')
    }

    $scope.selectCategory = (category) => {
        $scope.selected.category = category
        if ($scope.selected.category.id) {
            $scope.fetchAccountInfo($scope.selected.category.id)
        } else {
            $scope.refreshCategory()
        }
    }

    $scope.stopProp = (e) => {
        e.stopPropagation()
    }

    $scope.refreshAccount = (account) => {
        if (account) {
            $scope.selected.account = account
        }
        MetaWatcher.notif('MNG_ACCOUNT_CHANGED')
    }

    $scope.casesTranslate = {
        COURS: 'Affaires ouvertes',
        ANNUL: 'Affaires annulées',
        TERMN: 'Affaires closes',
        ERROR: 'Retours ENEDIS en erreur des 30 derniers jours',
    }

    const computeAccountStats = (account) => {
        _.assign(account, {
            stats: {
                pdls: _.groupBy(account.pdls, 'status'),
            },
            incompleteCategories: _.filter(account.categories, { complete: false }),
        })
    }

    $scope.accountContacts = {
        refreshing: false,
        counts: [15, 25, 50],
        columns: {
            categories: { label: 'Paquets', mode: 'search_wildcard' },
            affectation: { label: 'Affectations', mode: 'hidden' },
            civ: { label: 'Civilité', mode: 'search_wildcard' },
            givenname: { label: 'Prénom', mode: 'search_wildcard' },
            sn: { label: 'Nom', mode: 'search_wildcard' },
            phone: { label: 'Téléphone', mode: 'search_wildcard' },
            mail: { label: 'E-mail', mode: 'search_wildcard' },
            role: { label: 'Rôle', mode: 'search_wildcard' },
            comment: { label: 'Commentaires', mode: 'search_wildcard' },
        },
    }

    $scope.principalContactPayload = {}
    $scope.principalContactTemplate = {
        principal_civ: { label: 'Civilité *', required: true, type: 'select', enum: [{ value: 'M.', label: 'M.' }, { value: 'Mme', label: 'Mme' }] },
        principal_givenname: { label: 'Prénom *', type: 'text', required: true },
        principal_sn: { label: 'NOM *', type: 'text', required: true },
        principal_mail: { label: 'E-mail', type: 'email', required: true },
        principal_phone: { label: 'Téléphone', type: 'phone-all', required: true },
        principal_role: { label: 'Rôle', type: 'text' },
        principal_comment: { label: 'Commentaires', type: 'text' },
    }

    $scope.contactPayload = {}
    $scope.contactTemplate = {
        civ: { label: 'Civilité *', required: true, type: 'select', enum: [{ value: 'M.', label: 'M.' }, { value: 'Mme', label: 'Mme' }] },
        givenname: { label: 'Prénom *', type: 'text', required: true },
        sn: { label: 'NOM *', type: 'text', required: true },
        mail: { label: 'E-mail', type: 'email' },
        phone: { label: 'Téléphone', type: 'phone-all' },
        role: { label: 'Rôle', type: 'text' },
        comment: { label: 'Commentaires', type: 'text' },
    }

    $scope.secondaryContactPayload = {}
    $scope.secondaryContactTemplate = {
        secondary_civ: { label: 'Civilité *', required: true, type: 'select', enum: [{ value: 'M.', label: 'M.' }, { value: 'Mme', label: 'Mme' }] },
        secondary_givenname: { label: 'Prénom *', type: 'text', required: true },
        secondary_sn: { label: 'NOM *', type: 'text', required: true },
        secondary_mail: { label: 'E-mail', type: 'email' },
        secondary_phone: { label: 'Téléphone', type: 'phone-all' },
        secondary_role: { label: 'Rôle', type: 'text' },
        secondary_comment: { label: 'Commentaires', type: 'text' },
    }

    $scope.otherContactPayload = {}
    $scope.otherContactTemplate = {
        other_civ: { label: 'Civilité *', required: true, type: 'select', enum: [{ value: 'M.', label: 'M.' }, { value: 'Mme', label: 'Mme' }] },
        other_givenname: { label: 'Prénom *', type: 'text', required: true },
        other_sn: { label: 'NOM *', type: 'text', required: true },
        other_mail: { label: 'E-mail', type: 'email' },
        other_phone: { label: 'Téléphone', type: 'phone-all' },
        other_role: { label: 'Rôle', type: 'text' },
        other_comment: { label: 'Commentaires', type: 'text' },
    }

    const contactTypeTranslate = {
        BILLING: 'Facturation',
        PRINCIPAL: 'Principal',
        SECONDARY: 'Secondaire',
        OTHER: 'Autre',
    }

    const transformContacts = (data) => {
        const mails = [$scope.selected.account.mail]
        const phones = [$scope.selected.account.phone]
        _.each(data, (datum) => {
            datum.types = _.uniq(_.map(datum.affectation.split(','), (elem) => contactTypeTranslate[elem.split('_').pop()])).join(',')
            mails.push(datum.mail)
            phones.push(datum.phone)
        })
        MetaWatcher.notif('SWITCHED_ACCOUNT_OR_CATEGORY', { customer_id: $scope.selected.account.customer_id, mails: _.compact(_.uniq(mails)), phones: _.compact(_.uniq(phones)) })
    }

    $scope.fetchAccountContact = () => {
        TableGeneratorService.getTable($scope.accountContacts, 'b2g-contacts', null, transformContacts, { search: { id_account: $scope.selected.account.id }, orderBy: 'sn' })
    }

    $scope.refreshCategory = () => {
        if ($scope.selected.category && $scope.selected.category.id) {
            const mails = _.compact([$scope.selected.account.mail])
            const phones = _.compact([$scope.selected.account.phone])

            return DataAccess.getRefContractCategory({ id_category: $scope.selected.category.id }).$promise
            .then((category) => {
                _.assign($scope.selected.category, category)
                _.each(Object.keys($scope.selected.category), (key) => {
                    if (key.includes('phone')) {
                        phones.push($scope.selected.category[key])
                    } else if (key.includes('mail') && key !== 'do_not_send_email') {
                        mails.push($scope.selected.category[key])
                    }
                })
            })
            .catch(ErrorCatcher)
            .finally(() => {
                MetaWatcher.notif('SWITCHED_ACCOUNT_OR_CATEGORY', { customer_id: $scope.selected.account.customer_id, mails: _.compact(_.uniq(mails)), phones: _.compact(_.uniq(phones)) })
            })
        }
        $scope.fetchAccountContact()
    }

    $scope.fetchAccountInfo = (id_category) => {
        $scope.selected.account.fetching = true
        const myAccountPayload = { id: $scope.selected.account.id, light: true }
        if (id_category) {
            myAccountPayload.id_category = id_category
        }
        return DataAccess.myAccount(myAccountPayload).$promise
        .then((accountDetails) => {
            _.assign($scope.selected.account, accountDetails.toJSON(), { fetched: true })
            computeAccountStats($scope.selected.account)
            if (id_category) {
                $scope.refreshCategory()
            } else {
                $scope.selected.categories = _.orderBy(_.cloneDeep($scope.selected.account.categories), 'name')
                $scope.selected.categories.unshift(allCats)
                $scope.selected.category = allCats
                $scope.emptyCategory()
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.selected.account.fetching = false
            $scope.fetchAccountContact()
            $scope.updateNbTicket()
        })
    }

    const updateAccount = () => {
        if ($scope.selected.account && !$scope.selected.account.fetching) {
            return $scope.fetchAccountInfo()
        }
    }

    const updatePage = () => {
        const selectedId = ($scope.selected.account && $scope.selected.account.id) || $stateParams.id_account
        $scope.updatingPage = true
        return DataAccess.myAccounts({ light: true }).$promise
        .then((accounts) => {
            $scope.accounts = accounts
            if (!selectedId) {
                $scope.selected = {
                    account: $scope.accounts[0],
                }
            } else {
                $scope.selected = {
                    account: _.find($scope.accounts, { id: selectedId }),
                }
            }
            return updateAccount()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.updatingPage = false
        })
    }

    MetaWatcher.watch('MNG_ACCOUNT_CHANGED', 'b2gHome', $scope, updateAccount)

    MetaWatcher.watch('MNG_CONTACTS_CHANGED', 'b2gHome', $scope, $scope.fetchAccountContact)

    $scope.displayContactInfo = () => {
        $scope.shouldDisplayContactInfo = !$scope.shouldDisplayContactInfo
    }

    $scope.goTo = (page, params) => {
        const url = $state.href(page, params)
        window.open(url, '_blank')
    }

    $scope.updateNbTicket = () => {
        return Promise.all([
            $scope.updateNbTicketForStatus('OPEN', `"A traiter - support","En attente","En cours - support","En cours d'investigation",` +
                `"En cours de support",Ouverte,Réouvert,"Travail en cours"`),
            $scope.updateNbTicketForStatus('WAITING_CLIENT', 'En attente demandeur'),
            $scope.updateNbTicketForStatus('WAITING_GRD', `"En attente GRD","Relance GRD"`),
            $scope.updateNbTicketForStatus('CLOSED', `Done,Résolu`),
        ])
    }

    $scope.updateNbTicketForStatus = (id, status) => {
        // Fetch project epic issue
        const params = {}
        params.filter = () => ({
            idCustomer: $scope.selected.account.customer_id,
            status,
        })
        $scope.fetchingJiraTickets = true
        return JiraService.getData(params, $scope.selected.account.organization, 'key').$promise.then((response) => {
            $scope.nbTicket[id] = response.results.total
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.fetchingJiraTickets = false
        })
    }

    $scope.openNewJiraModal = () => {
        ModalService.openModal({ type: 'newJiraModal', size: 'md' }, { accounts: [$scope.selected.account] })
    }

    $scope.prepareContactPayload = (c) => {
        _.assign($scope.contactPayload, _.pick(c, ['civ', 'givenname', 'sn', 'mail', 'phone']))
    }

    $scope.prepareSecondaryContactPayload = (c) => {
        _.assign($scope.secondaryContactPayload, _.pick(c, ['secondary_civ', 'secondary_givenname', 'secondary_sn', 'secondary_mail', 'secondary_phone']))
    }

    $scope.preparePrincipalContactPayload = (c) => {
        _.assign($scope.principalContactPayload, _.pick(c, ['principal_civ', 'principal_givenname', 'principal_sn', 'principal_mail', 'principal_phone']))
    }

    $scope.prepareOtherContactPayload = (c) => {
        _.assign($scope.otherContactPayload, _.pick(c, ['other_civ', 'other_givenname', 'other_sn', 'other_mail', 'other_phone']))
    }

    $scope.updateCategory = (c, payload) => {
        c.modifying = true
        delete payload.id
        return DataAccess.updateRefContractCategory({ id: c.id }, payload).$promise.then(() => {
            AlertManager.success('Paquet facturier mis à jour')
            $scope.refreshCategory()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            c.modifying = false
        })
    }

    $scope.refreshTechnicalContacts = () => {
        $scope.fetchingTechnicalContacts = true
        return DataAccess.fetchTechnicalContactsForAccount({ id_account: _.get($scope.selected, 'account.id'), id_category: _.get($scope.selected, 'category.id') }).$promise
        .then((results) => {
            $scope.technicalContacts = results
            $scope.technicalContactsTable = new NgTableParams({}, { dataset: results })
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.fetchingTechnicalContacts = false
        })
    }

    $scope.massUpdateAdditionalContactsFields = {
        civ: { label: 'Civilité', type: 'radio', required: true, enum: [{ value: 'M.', label: 'M.' }, { value: 'Mme', label: 'Mme' }] },
        givenname: { label: 'Prénom', type: 'text', required: true },
        sn: { label: 'NOM', type: 'text', required: true },
        email: { label: 'E-mail', type: 'emails', required: true },
        phone: { label: 'Téléphone', type: 'phone-all', required: true },
    }

    $scope.prepareMassUpdateAdditionalContactsPayload = (contact) => {
        contact.update = contact.update || _.omit(contact, ['ids', 'idsContract'])
    }

    $scope.massUpdateAdditionalContacts = (contact) => {
        $scope.massUpdatingAdditionalContacts = true
        return DataAccess.massUpdateAdditionalContacts(_.assign({}, _.pick(contact, ['ids']), contact.update)).$promise
        .then(() => {
            AlertManager.success('Contacts mis à jour')
            $scope.refreshTechnicalContacts()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.massUpdatingAdditionalContacts = false
        })
    }

    MetaWatcher.watch('SWITCHED_ACCOUNT_OR_CATEGORY', 'csrB2gHome', $scope, $scope.refreshTechnicalContacts)

    const activate = () => {
        updatePage()
    }

    activate()
})
